<template><div><h1>VUX V2.1.1Rc.11 released</h1>
<h2><a href="/en/components/actionsheet.html">Actionsheet</a></h2>
<ul><li>[enhance] Better transition for mask</li>
</ul>
<h2><a href="/en/components/alert.html">Alert</a></h2>
<ul><li>[enhance] Reset props data when used as plugin</li>
</ul>
<h2><a href="/en/components/confirm.html">Confirm</a></h2>
<ul><li>[fix] Fix plugin value and event watchers</li>
<li>[fix] Reset prop data when used as plugin</li>
</ul>
<h2><a href="/en/components/datetime.html">Datetime</a></h2>
<ul><li>[feature] Support prop:display-format #1086 @greedying</li>
</ul>
<h2><a href="/en/components/loading.html">Loading</a></h2>
<ul><li>[enhance] Reset prop data when used as plugin</li>
<li>[enhance] Add fade transition</li>
</ul>
<h2><a href="/en/components/popup-picker.html">PopupPicker</a></h2>
<ul><li>[enhance] Fix mask render slowly in Safari. #1083 @sixiakun</li>
<li>[enhance] Enable transfer-dom by default</li>
</ul>
<h2><a href="/en/components/popup.html">Popup</a></h2>
<ul><li>[fix] Fix wrong overflowScrolling when mask is disabled</li>
</ul>
<h2><a href="/en/components/x-dialog.html">XDialog</a></h2>
<ul><li>[enhance] Better mask transition and dialog transition</li>
<li>[enhance] Add transfer-dom demo</li>
<li>[enhance] Clean unused code</li>
</ul>
<h2><a href="/en/components/x-textarea.html">XTextarea</a></h2>
<ul><li>[feature] Add on-focus on-blur event #1082 @zeusLeeJh</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.1.1Rc.11 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.1-rc.11-86.vue?e3625934